import { type ReactNode } from 'react'
import { cn } from '@/lib/utils'

type ContainerProps = {
  children: ReactNode
  className?: string
  /** Narrower reading width for policies / long copy */
  narrow?: boolean
}

export function Container({ children, className, narrow }: ContainerProps) {
  return (
    <div
      className={cn(
        'mx-auto w-full max-w-[1280px] px-4 sm:px-6 lg:px-8',
        narrow && 'max-w-[720px]',
        className
      )}
    >
      {children}
    </div>
  )
}
